/**
 * @param empresa user empresa data
 */
export default ({ empresa }) => ({
  isPartner: empresa.isPartner === true,
});
